import { useEffect, useState } from "react";
import { Phone, MapPin, Mail } from "lucide-react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

const SERVICES = [
  "Complete Pool Remodels",
  "Equipment Upgrades",
  "Pool Automation",
  "Spa Additions",
  "Sun Shelf Additions",
  "Tile & Coping",
  "Interior Finishes",
  "Water Features",
  "New Plumbing",
];

const AREAS = [
  "Pompano Beach",
  "Fort Lauderdale",
  "Boca Raton",
  "Delray Beach",
  "Deerfield Beach",
  "Coral Springs",
  "Parkland",
];

export default function SiteFooter() {
  const [logo, setLogo] = useState(null);

  useEffect(() => {
    api
      .get("/site-images")
      .then((res) => setLogo(res.data?.logo || null))
      .catch(() => setLogo(null));
  }, []);

  return (
    <footer className="bg-[#0F3A5A] text-slate-200 relative overflow-hidden" data-testid="site-footer">
      <div className="absolute inset-0 opacity-[0.08] pointer-events-none" style={{
        backgroundImage: "radial-gradient(circle at 20% 10%, #00B4D8 0%, transparent 40%)"
      }} />
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 pt-20 pb-10 relative">
        <div className="grid lg:grid-cols-4 gap-12 mb-14">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5 mb-5">
              {logo ? (
                <img
                  src={logo}
                  alt="AZ Pools"
                  className="h-10 w-auto max-w-[180px] object-contain brightness-0 invert"
                />
              ) : (
                <>
                  <span className="grid place-items-center w-10 h-10 rounded-xl bg-[#00B4D8] text-white font-display font-bold text-lg">
                    AZ
                  </span>
                  <span className="font-display font-semibold text-xl tracking-tight text-white">AZ Pools</span>
                </>
              )}
            </div>
            <p className="text-sm text-slate-300 leading-relaxed mb-5">
              Luxury pool renovations built to last. Serving South Florida homeowners
              with quality craftsmanship and premium materials.
            </p>
            <p className="text-xs uppercase tracking-[0.25em] text-[#00B4D8] font-semibold">
              Licensed & Insured
            </p>
          </div>

          <div>
            <h4 className="font-display font-semibold text-white text-base mb-5">Services</h4>
            <ul className="space-y-2.5 text-sm">
              {SERVICES.map((s) => (
                <li key={s} className="text-slate-300 hover:text-white transition">{s}</li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold text-white text-base mb-5">Service Areas</h4>
            <ul className="space-y-2.5 text-sm">
              {AREAS.map((a) => (
                <li key={a} className="text-slate-300">{a}</li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold text-white text-base mb-5">Contact</h4>
            <ul className="space-y-3.5 text-sm">
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 text-[#00B4D8] mt-0.5 shrink-0" />
                <a href="tel:9543288083" className="text-slate-200 hover:text-white">
                  954-328-8083
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 text-[#00B4D8] mt-0.5 shrink-0" />
                <a href="mailto:azpooldesigns@gmail.com" className="text-slate-200 hover:text-white break-all">
                  azpooldesigns@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-[#00B4D8] mt-0.5 shrink-0" />
                <span className="text-slate-300">
                  Pompano Beach, FL<br />Proudly serving South Florida
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row gap-4 items-center justify-between">
          <p className="text-xs text-slate-400">
            © {new Date().getFullYear()} AZ Pools. All rights reserved.
          </p>
          <p className="text-sm font-display italic text-[#A8D8F0]">
            “Luxury Pool Renovations Built to Last.”
          </p>
          <Link
            to="/admin/login"
            className="text-xs text-slate-500 hover:text-slate-300"
            data-testid="footer-admin-link"
          >
            Admin
          </Link>
        </div>
      </div>
    </footer>
  );
}
